const URL_PARAM_KEY = 'id_token';
const COOKIE_KEY = 'id_token';
const AUTH_CODE = 'code';
const REFRESH_TOKEN = 'refresh_token';
const IDENTITY_PROVIDER = 'identity_provider';
const SIGNED_OUT = 'signed_out';

export default { URL_PARAM_KEY, COOKIE_KEY, AUTH_CODE, REFRESH_TOKEN, IDENTITY_PROVIDER, SIGNED_OUT };
